import { render, staticRenderFns } from "./ResumoVenda.vue?vue&type=template&id=51e2e9f9"
import script from "./ResumoVenda.vue?vue&type=script&lang=js"
export * from "./ResumoVenda.vue?vue&type=script&lang=js"
import style0 from "./ResumoVenda.vue?vue&type=style&index=0&id=51e2e9f9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports